/*
 * The floating "order by" tile (Shai's redesign part 3, SPEC.md 3b). Markup and styles: snippets/mv-order-tile.liquid.
 * Dates: assets/mv-delivery.js. Events: delivery_tile_shown (once a page), delivery_tile_clicked, delivery_tile_minimized,
 * delivery_tile_opened, and delivery_zip_changed {from: 'tile'} from mvDelivery.setZip. data-start="small" (Ideas pages):
 * the tile starts as the date pill until the shopper opens it (mv_tile_open, for the session); events carry start_small.
 */
(function () {
  const root = document.querySelector('[data-mvt]');
  if (!root || root.dataset.ready || !window.mvDelivery) return;
  root.dataset.ready = '1';
  const D = window.mvDelivery, page = root.dataset.page || 'page';
  const $ = (s) => root.querySelector(s);
  const card = $('[data-mvt-card]'), pill = $('[data-mvt-pill]'), eye = $('[data-mvt-eye]'), date = $('[data-mvt-date]'), ask = $('[data-mvt-ask]');
  const note = $('[data-mvt-note]'), noteText = note ? note.textContent : '';
  const zip = $('[data-mvt-zip]'), zipLabel = $('[data-mvt-ziplabel]'), pillText = $('[data-mvt-pilltext]');
  const watch = root.dataset.watch ? document.querySelector(root.dataset.watch) : null;
  const follow = root.dataset.follow ? root.dataset.follow : null;
  // It stops above the footer, or above the page's final call-to-action band where there is one (Home, Ideas pages).
  const footer = document.querySelector('.mvh-final, .mvi-final') || document.querySelector('footer');
  const track = (n, p) => { try { if (window.mvTrack) window.mvTrack(n, { page, ...(small ? { start_small: true } : {}), ...(p || {}) }); } catch (_) {} };
  document.documentElement.classList.add('mvt-has');
  let d = null, up = false, seen = false;
  const small = root.dataset.start === 'small';
  let mini = small;
  try { mini = sessionStorage.getItem('mv_tile_min') === '1' || (small && sessionStorage.getItem('mv_tile_open') !== '1'); } catch (_) {}

  function paint() {
    if (!d) return;
    const has = !!d.arrives;
    date.hidden = !has; ask.hidden = has;
    eye.textContent = has ? D.lead(d) : 'Free delivery on every order';
    if (has) date.textContent = D.day(d.arrives);
    const place = d.city ? `${d.city}${d.region ? ', ' + d.region : ''}` : '';
    zipLabel.textContent = !has ? 'Your ZIP' : d.typed ? 'Delivering to' : d.fallback ? 'Est. date · your ZIP' : place ? `Est. for ${place} area` : 'Est. for your area';
    zipLabel.classList.toggle('is-est', has && !d.typed);
    if (document.activeElement !== zip) zip.value = d.zip || '';
    if (note) note.textContent = has && d.zip && !d.fallback ? `${noteText} to ${d.zip}` : noteText;
    pillText.textContent = has ? `Get it by ${D.day(d.arrives)}` : 'Get a delivery date';
    card.hidden = mini; pill.hidden = !mini;
    measure();
  }
  async function load() { d = await (D.estimate ? D.estimate() : D.get()); paint(); }

  // Shown once the page's main button is above the screen; hidden while it is on screen; above the footer.
  function place() {
    let show;
    if (watch) { const r = watch.getBoundingClientRect(); show = r.bottom < 0 && !(r.width === 0 && r.height === 0); }
    else show = scrollY > 400;
    if (show !== up) {
      up = show; root.classList.toggle('is-up', up); document.documentElement.classList.toggle('mvt-on', up);
      if (up && !seen && d) { seen = true; track('delivery_tile_shown', { has_date: !!d.arrives, typed_zip: d.typed, left_min: d.leftMin, minimized: mini }); }
    }
    let lift = 0;
    if (footer) { const f = footer.getBoundingClientRect(); if (f.top < innerHeight) lift = Math.round(innerHeight - f.top); }
    root.style.setProperty('--mvt-lift', `${lift}px`);
  }
  function measure() { document.documentElement.style.setProperty('--mvt-h', `${Math.round(root.getBoundingClientRect().height)}px`); }

  zip.addEventListener('input', () => {
    const v = zip.value.replace(/\D/g, '').slice(0, 5);
    if (v !== zip.value) zip.value = v;
    if (v.length === 5) D.setZip(v, 'tile');
  });
  zip.addEventListener('keydown', (e) => { if (e.key === 'Enter') zip.blur(); });
  addEventListener('mv:zip', load);
  root.querySelectorAll('[data-mvt-go]').forEach((a) => a.addEventListener('click', () => {
    const f = follow && document.querySelector(follow);
    if (f && f.href) {
      const u = new URL(f.href, location.href); u.searchParams.set('src', `tile-${page}`); a.href = u.toString();
    }
    track('delivery_tile_clicked', { cta: a.textContent.trim(), minimized: mini, has_date: !!(d && d.arrives) });
  }));
  $('[data-mvt-min]').addEventListener('click', () => {
    mini = true; try { sessionStorage.setItem('mv_tile_min', '1'); sessionStorage.removeItem('mv_tile_open'); } catch (_) {}
    paint(); track('delivery_tile_minimized'); $('[data-mvt-open]').focus();
  });
  $('[data-mvt-open]').addEventListener('click', () => {
    mini = false; try { sessionStorage.removeItem('mv_tile_min'); sessionStorage.setItem('mv_tile_open', '1'); } catch (_) {}
    paint(); track('delivery_tile_opened'); zip.focus();
  });

  let q = false;
  const queue = () => { if (!q) { q = true; requestAnimationFrame(() => { q = false; place(); }); } };
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', () => { queue(); measure(); });
  // The countdown moves every 30 seconds (and the date, when the cutoff passes).
  setInterval(load, 30000);
  load().then(place);
  place();
})();
